import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitMfgSalesOrderLinesPayload {
    mItemID: number;
}

async function commitMfgSalesOrderLines(
    payload: ICommitMfgSalesOrderLinesPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitMfgSalesOrderLines",
        payload.mItemID,
        { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
}

export function useCommitMfgSalesOrderLines() {
    return useMutation({
        mutationFn: commitMfgSalesOrderLines,
    });
}
